<template>
<div class="hover-btn" id="hoverbtn" @click="gopage">
    <img src="../assets/img/pk1.gif" alt />
</div>
</template>

<script>
export default {
    name: "hoverButton",
    props: ['condition','acquisitionTime'],
    data(){
      return{
        isPhoneShow:false,
      }
    },
    mounted: function () {
        this.drag();
    },
    methods: {
        // 跳转到排行榜页面
        gopage() {
          if(this.condition !== 0 || this.acquisitionTime == 4 ) {
              this.isPhoneShow = false;
              this.$router.push({
                  path: "/rankingList"
              });
              sessionStorage.setItem('isPopupPhoneShow',false)
          }else {
              this.isPhoneShow = true;
          }
          this.$emit('isPhoneShow', this.isPhoneShow, true);
        },
        // 初始化页面按钮的拖拽方法
        drag() {
            // 获取按钮元素
            var btnel = document.getElementById("hoverbtn");
            var oW, oH;
            // 绑定touchstart事件，
            btnel.addEventListener(
                "touchstart",
                function (e) {
                    var touches = e.touches[0];
                    oW = touches.clientX - btnel.offsetLeft;
                    oH = touches.clientY - btnel.offsetTop;
                },
                false
            );
            // 绑定move事件，move时改变按钮位置
            btnel.addEventListener(
                "touchmove",
                function (e) {
                    e.preventDefault();
                    var touches = e.touches[0];
                    var oLeft = touches.clientX - oW;
                    var oTop = touches.clientY - oH;
                    if (oLeft < 0) {
                        oLeft = 0;
                    } else if (
                        oLeft >
                        document.documentElement.clientWidth - btnel.offsetWidth
                    ) {
                        oLeft = document.documentElement.clientWidth - btnel.offsetWidth;
                    }

                    if (oTop < 0) {
                        oTop = 0;
                    } else if (
                        oTop >
                        document.documentElement.clientHeight - btnel.offsetHeight
                    ) {
                        oTop = document.documentElement.clientHeight - btnel.offsetHeight;
                    }
                    btnel.style.left = oLeft + "px";
                    btnel.style.top = oTop + "px";
                },
                false
            );

            btnel.addEventListener(
                "touchend",
                function (e) {
                    var endLeft = e.changedTouches[0].pageX;
                    if (endLeft > document.documentElement.clientWidth / 2) {
                        btnel.style.left =
                            document.documentElement.clientWidth - btnel.offsetWidth + "px";
                    } else if (endLeft < document.documentElement.clientWidth / 2) {
                        btnel.style.left = 0 + "px";
                    }
                    if (e.changedTouches[0].pageY < btnel.offsetHeight) {
                        btnel.style.top = 0 + "px";
                    }
                },
                false
            );
        },
    },
};
</script>

<style lang="less" scoped>
.hover-btn {
    color: #fff;
    font-size: 0.6rem;
    text-align: center;
    width: 132px;
    height: 111px;
    position: fixed;
    right: 0%;
    bottom: calc(50% - 100px);
    // border-radius: 50%;
    z-index: 9999;

    img {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hoverButton.vue